import React from "react";
import { useNavigate } from "react-router-dom";

import { HubContextMenu } from "../../components";

const MENU_ITEMS = [
  {
    id: "edit",
    label: "Edit Purchase Order",
    icon: "Settings",
  },
  {
    id: "delete",
    label: "Delete",
    icon: "Trash2",
    color: "redError",
  },
];

export const CustomerOrderContextMenu = ({
  id,
  setDeletingId = () => { },
  _setIsOpenDialog = () => { },
  ...rest
}) => {
  const navigate = useNavigate();

  const onSelect = (item) => {
    switch (item?.id) {
      case "edit":
        navigate(`/orders/${id}`);
        break;
      case "delete":
        setDeletingId(id);
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"orders"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{
        sx: {
          padding: "0px !important",
        },
      }}
      {...rest}
    />
  );
};

export default CustomerOrderContextMenu
